import { css } from 'styled-components';

export const shadows = {
	base: css`
		box-shadow: 0 2px 8px -2px ${({ theme }) => theme.general.shadowColor};
	`
};
